var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-btn",
    {
      staticClass: "bg-white no-padding",
      staticStyle: { margin: "1rem auto" },
      on: { click: _vm.handleClick }
    },
    [
      _c(
        "div",
        {
          staticClass: "text-weight-bold",
          staticStyle: {
            "font-size": "medium",
            display: "flex",
            "flex-direction": "column",
            "align-items": "center",
            "justify-content": "center",
            padding: "1.5rem"
          }
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.time))]),
          _c("p", [_vm._v(_vm._s(_vm.year))])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }